// REQUISITION_TYPE_CONFIG lives in the shared constants layer; imported for
// the local OPTIONS derivation below and re-exported for existing callers.
import { REQUISITION_TYPE_CONFIG } from '@/constants/requisition-constants';

// Backend enum values - these should match your backend exactly
export const BACKEND_ENUMS = {
  employment_type: {
    full_time: 0,
    part_time: 1,
    contract: 2,
    internship: 3,
    temporary: 4,
    seasonal: 5,
  },
  requisition_type: {
    new_hire: 0,
    backfill: 2,
    internal: 4,
  },
} as const;

// Type definitions derived from backend enums
export type EmploymentType = keyof typeof BACKEND_ENUMS.employment_type;
export type RequisitionType = keyof typeof BACKEND_ENUMS.requisition_type;

// Mappings for form submission (same as backend values)
export const EMPLOYMENT_TYPE_MAPPING = BACKEND_ENUMS.employment_type;
export const REQUISITION_TYPE_MAPPING = BACKEND_ENUMS.requisition_type;

// UI Configuration for display
export const EMPLOYMENT_TYPE_CONFIG: Record<
  EmploymentType,
  { label: string; color: string }
> = {
  full_time: { label: 'Full-time', color: 'blue' },
  part_time: { label: 'Part-time', color: 'green' },
  contract: { label: 'Contract', color: 'orange' },
  internship: { label: 'Internship', color: 'cyan' },
  temporary: { label: 'Temporary', color: 'gray' },
  seasonal: { label: 'Seasonal', color: 'teal' },
};

// REQUISITION_TYPE_CONFIG re-exported from the shared constants layer.
export { REQUISITION_TYPE_CONFIG };

// Form options for dropdowns
export const EMPLOYMENT_TYPE_OPTIONS = Object.keys(EMPLOYMENT_TYPE_CONFIG).map(
  (key) => ({
    label: EMPLOYMENT_TYPE_CONFIG[key as EmploymentType].label,
    value: key as EmploymentType,
  })
);

export const REQUISITION_TYPE_OPTIONS = Object.keys(
  REQUISITION_TYPE_CONFIG
).map((key) => ({
  label: REQUISITION_TYPE_CONFIG[key as RequisitionType].label,
  value: key as RequisitionType,
}));

// Default values
export const ENUM_DEFAULTS = {
  employment_type: 'full_time' as EmploymentType,
  requisition_type: 'new_hire' as RequisitionType,
} as const;
